"use client";
import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Separator } from "@/components/ui/separator";
import { Textarea } from "@/components/ui/textarea";
import { cn } from "@/lib/utils";

interface Props {
    title?: React.ReactNode;
    header?: React.ReactNode;
    description?: string;
    children: React.ReactNode;
    className?: string;
    noBorder?: boolean;
    titleSize?: "default" | "md" | "sm";
}

export default function CardSetting({
    title,
    description,
    children,
    className,
    header,
    noBorder,
    titleSize = "default",
}: Props) {
    return (
        <Card
            className={cn(
                "bg-card p-3 pt-3",
                className,
                noBorder && "border-none"
            )}
        >
            {(title || description) && (
                <CardHeader className="z-40 p-0 pb-2">
                    {header && header}
                    {title && (
                        <CardTitle
                            className={cn(
                                "z-40",
                                titleSize == "default" && "text-lg",
                                titleSize == "md" && "text-sm",
                                titleSize == "sm" && "text-xs"
                            )}
                        >
                            <Label variant={"headingtoggle"}>{title}</Label>
                        </CardTitle>
                    )}
                    {description && (
                        <CardDescription className="!mt-0 text-xs">
                            {description}
                        </CardDescription>
                    )}
                </CardHeader>
            )}

            <CardContent className="p-0">{children}</CardContent>
        </Card>
    );
}
